export enum EUnitType {
  ONE_BEDROOM = "1",
  TWO_BEDROOM = "2",
  THREE_BEDROOM = "3",
  FOUR_BEDROOM = "4",
  FIVE_BEDROOM = "5",
  STUDIO = "true",
}
